export class Alert {
    id?: string;
    type?: AlertType;
    message?: any |string | string[] | { [key: string]: string | string[]};
    autoClose = true;
    keepAfterRouteChange?: boolean;
    fade?: boolean;
    pageType?: AlertPage;

    constructor(init?: Partial<Alert>) {
        Object.assign(this, init);
    }
}

export enum AlertType {
    Success = "Success",
    Error = "Error",
    Info = "Info",
    Warning = "Warning"
}

export class ConfirmContent {
    constructor(message: string,btn1Txt?: string, btn2Txt?: string) {
        this.message = message;
        if(btn1Txt && btn2Txt) {
            this.btn1Txt = btn1Txt;
            this.btn2Txt = btn2Txt;
        }
    }
    message!: string;
    btn1Txt = 'Ok';
    btn2Txt = 'Cancel';
}

export class AlertOptions {
    id?: string;
    autoClose?: boolean;
    keepAfterRouteChange?: boolean = true;
    displayType?: AlertPage;
}

export interface ConfirmOptions {
    title?: string;
    confirmText?: string;
    cancelText?: string;
    danger?: boolean;
}

export interface ConfirmRequest {
    message: string;
    options: ConfirmOptions;
    resolve: (result: boolean) => void;
}

export enum AlertPage {
    LOGIN,
}
